/**
 * Buyer/Arendator Enums and Constants
 */

// Wall Type Options (31 variants from schema)
export const WALL_TYPES = [
  { value: 'panel', label: 'Панель' },
  { value: 'brick', label: 'Цегла' },
  { value: 'wood', label: 'Дерево' },
  { value: 'wood_brick', label: 'Дерево/Цегла' },
  { value: 'slag', label: 'Шлакоблок' },
  { value: 'foam', label: 'Піноблок' },
  { value: 'shell', label: 'Черепашник (Ракушняк)' },
  { value: 'carcas', label: 'Каркасний' },
  { value: 'silicat', label: 'Силікатна цегла' },
  { value: 'monolith', label: 'Моноліт' },
  { value: 'block', label: 'Блочно-цегляний' },
  { value: 'monolith-brick', label: 'Монолітно-цегляний' },
  { value: 'monolith-beton', label: 'Монолітний залізобетон' },
  { value: 'carcas-stone', label: 'Каркасно-кам\'яна' },
  { value: 'obliz', label: 'Облицювальна цегла' },
  { value: 'steel-beton', label: 'Залізобетон' },
  { value: 'keram-brick', label: 'Керамічна цегла' },
  { value: 'complex-monolith', label: 'Збірно-монолітна' },
  { value: 'sip', label: 'СІП' },
  { value: 'no-carcas', label: 'Безкаркасна' },
  { value: 'monolith-block', label: 'Монолітно-блоковий' },
  { value: 'arm-beton', label: 'Армований залізобетон' },
  { value: 'complex-beton', label: 'Збірний залізобетон' },
  { value: 'arm-3d-panel', label: 'Армована 3D панель' },
  { value: 'gaz-block', label: 'Газоблок' },
  { value: 'monolith-carcas', label: 'Монолітно-каркасний' },
  { value: 'inkerman', label: 'Інкерманський камінь' },
  { value: 'but', label: 'Бутовий камінь' },
  { value: 'gaz-beton', label: 'Газобетон' },
  { value: 'keram-block', label: 'Керамічний блок' },
  { value: 'keramzit-beton', label: 'Керамзитобетон' },
]

// Amenities Options
export const AMENTIES_OPTIONS = [
  { value: 'yes', label: 'Так' },
  { value: 'no', label: 'Ні' },
]

// Helper function to get wall type options for Select
export function getWallTypeOptions() {
  return [
    { value: '', label: 'Не обрано' },
    ...WALL_TYPES,
  ]
}

// Helper function to get amenties options for Select
export function getAmentiesOptions() {
  return [
    { value: '', label: 'Не обрано' },
    ...AMENTIES_OPTIONS,
  ]
}
